var React = require('react');

function Mobile (props) {
    return React.createElement("svg",props,React.createElement("g",null,React.createElement("path",{"d":"M19.494,0H7.948C6.843,0,5.951,0.896,5.951,1.999v23.446c0,1.102,0.892,1.997,1.997,1.997h11.546\n\t\tc1.103,0,1.997-0.895,1.997-1.997V1.999C21.491,0.896,20.597,0,19.494,0z M10.872,1.214h5.7c0.144,0,0.261,0.215,0.261,0.481\n\t\ts-0.117,0.482-0.261,0.482h-5.7c-0.145,0-0.26-0.216-0.26-0.482C10.612,1.429,10.727,1.214,10.872,1.214z M13.722,25.469\n\t\tc-0.703,0-1.275-0.572-1.275-1.276s0.572-1.274,1.275-1.274c0.701,0,1.273,0.57,1.273,1.274S14.423,25.469,13.722,25.469z\n\t\t M19.995,21.1H7.448V3.373h12.547V21.1z"})));
}

Mobile.defaultProps = {"version":"1.1","id":"Capa_1","x":"0px","y":"0px","fill":"white","viewBox":"0 0 27.442 27.442","style":{"enableBackground":"new 0 0 27.442 27.442"},"xmlSpace":"preserve"};

module.exports = Mobile;

Mobile.default = Mobile;
